export default [
  {
    name: 'Breakout Space',
    image: 'breakout_space.png'
  },
  {
    name: 'Cat 5E Cabling',
    image: 'cat_5E_cabling.png'
  },
  {
    name: 'Cleaning Service',
    image: 'cleaning_service.png'
  },
  {
    name: 'Electric Car Charging',
    image: 'electric_car_charging.png'
  },
  {
    name: 'Free Car Parking',
    image: 'free_car_parking.png'
  },
  {
    name: 'Garden Picnic Area',
    image: 'garden_picnic_area.png'
  },
  {
    name: 'Hi-speed Broadband Wifi',
    image: 'hi_speed_broadband_wifi.png'
  },
  {
    name: 'Hot Beverages Provided',
    image: 'hot_beverages_provided.png'
  },
  {
    name: 'On Site Gym',
    image: 'on_site_gym.png'
  },
  {
    name: 'Utilities Included',
    image: 'utilities_included.png'
  }
];
